import React from "react";
import { Database, Eye, FileText, Lock, ShieldCheck } from "lucide-react";

import { PublicLayout } from "@/components/layout/PublicLayout";
import { useTranslation } from "@/lib/i18n";
import { Card, CardContent } from "@/components/ui/card";

export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="mx-auto max-w-4xl space-y-10">
        <div className="space-y-4">
          <h1 className="text-4xl font-bold tracking-tight">{t("privacy_title")}</h1>
          <p className="text-lg text-muted-foreground">Chính sách này mô tả cách Cloudface thu thập, bảo vệ và xử lý dữ liệu trong môi trường doanh nghiệp.</p>
        </div>

        <div className="grid gap-6">
          <Card className="border-white/5">
            <CardContent className="space-y-6 p-6">
              <section className="space-y-3">
                <div className="flex items-center gap-2 text-primary">
                  <Eye className="h-5 w-5" />
                  <h2 className="text-xl font-semibold">1. Thu thập dữ liệu</h2>
                </div>
                <p className="leading-relaxed text-muted-foreground">
                  Hệ thống thu thập các định danh tài khoản, token thanh toán cần thiết cho xử lý giao dịch và log hoạt động để phục vụ audit. Cloudface không bán hoặc thương mại hóa prompt hay đầu ra của người dùng.
                </p>
              </section>

              <section className="space-y-3">
                <div className="flex items-center gap-2 text-primary">
                  <Database className="h-5 w-5" />
                  <h2 className="text-xl font-semibold">2. Lưu trú dữ liệu</h2>
                </div>
                <p className="leading-relaxed text-muted-foreground">
                  Cloudface hỗ trợ lựa chọn vùng lưu trữ tại Singapore và Việt Nam. Dữ liệu được quản lý trên hạ tầng có khả năng chịu lỗi cao và đi kèm cơ chế sao lưu tự động.
                </p>
              </section>

              <section className="space-y-3">
                <div className="flex items-center gap-2 text-primary">
                  <Lock className="h-5 w-5" />
                  <h2 className="text-xl font-semibold">3. Tiêu chuẩn bảo mật</h2>
                </div>
                <p className="leading-relaxed text-muted-foreground">
                  Mọi kết nối đều được mã hóa bằng TLS 1.3. Dữ liệu nội bộ được bảo vệ bằng masking cho thông tin nhạy cảm và cơ chế phân quyền chi tiết theo vai trò.
                </p>
              </section>

              <section className="space-y-3">
                <div className="flex items-center gap-2 text-primary">
                  <ShieldCheck className="h-5 w-5" />
                  <h2 className="text-xl font-semibold">4. Quyền của người dùng</h2>
                </div>
                <p className="leading-relaxed text-muted-foreground">
                  Khách hàng doanh nghiệp giữ toàn quyền sở hữu dữ liệu. Bạn có thể yêu cầu xuất dữ liệu hoặc xóa tài khoản bằng cách liên hệ tới <span className="text-primary underline">privacy@stv.vn</span>.
                </p>
              </section>
            </CardContent>
          </Card>

          <div className="flex items-start gap-4 rounded-2xl border border-dashed bg-muted/50 p-6">
            <FileText className="mt-1 h-6 w-6 shrink-0 text-muted-foreground" />
            <div className="space-y-1">
              <h3 className="font-semibold">Cần thêm chi tiết?</h3>
              <p className="text-sm text-muted-foreground">Bạn có thể yêu cầu tài liệu compliance chi tiết hơn từ đội vận hành để phục vụ quy trình đánh giá nội bộ.</p>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
